<template>
  <section class="result">
    <div class="result__icon">
      <van-image width="100" height="100" :src="success_img" />
    </div>
    <div class="result__title">支付成功</div>
    <div class="result__remark btn_box">
      温馨提示：支付成功后请尽快离场，超时后将重新计费。
    </div>
    <div class="result__countdown btn_box">
      重新计费倒计时:
      <van-count-down @finish="handleRefresh"
        :time="$enumObject.providerConfig[config.projectName].otherConfig.paymentCountdown" style="color:#FF3366;"
        ref="countDown" />
    </div>
    <div v-if="!isShowInvoive" class="result__tips btn_box">
      超时将产生额外费用
    </div>
    <!-- <div v-if="isShowInvoive" class="result__tips btn_box">
      退出本页面，将无法直接开具
    </div>
    <div v-if="isShowInvoive" class="btn_box bottom">
      <van-button size="large" :round="true" type="info" @click="invoice()">
        开具发票
      </van-button>
    </div> -->
  </section>
</template>

<script>
import success_img from '@/assets/payment-related/img_pay_success.png'
import { mapGetters } from 'vuex'
import { SetIssuer, getOrderById } from '@/api/invoice'
import config from '@/config/index'
// import store from "@/store";
import { Image, CountDown, Button } from 'vant'
export default {
  name: 'PaySuccess',
  computed: {
    ...mapGetters([
      'invoiceParkId',//parkid
    ])
  },
  components: {
    [Image.name]: Image,
    [CountDown.name]: CountDown,
    [Button.name]: Button,
  },
  data () {
    return {
      config,
      success_img,
      isShowInvoive: false,
      // isWX: false
    }
  },
  mounted () {
    this.vaildateCanInvioce()
    // if (store.getters.wx_token || store.getters.NBPSS || store.getters.NBPSS.openid) {
    //   this.isWX = true
    // }
  },
  methods: {
    vaildateCanInvioce () {
      SetIssuer({ parkId: Number(this.invoiceParkId) }).then(res => {
        if (!res.body) {
          this.isShowInvoive = false
        } else {
          this.isShowInvoive = true
        }
      }).catch(err => {
        this.$notify({
          type: 'danger',
          message: err
        })
      })
    },
    // 取url中参数
    getQueryVariable (variable) {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
      }
      return (false);
    },
    // 开具发票
    invoice () {
      if (Number(this.invoiceParkId) == 0) {
        let a = (this.getQueryVariable('ORDERID'))
        let ids = a.split("_")
        let params = {
          id: ids[1]
        }
        getOrderById(params).then(res => {
          // this.invoiceParkId = res.body.parkId
          this.$store.dispatch('invoice/SetParkId', res.body.parkId)
          res.body.outTradeNo = a
          res.body.chargeId = ids[1]
          this.$store.dispatch('invoice/SetPendingBill', [res.body])
          this.setInvoice()
        })
      } else {
        this.setInvoice()
      }
    },
    setInvoice () {
      let _this = this
      SetIssuer({ parkId: Number(_this.invoiceParkId) }).then(res => {
        if (!res.body) {
          _this.$toast.fail('暂无销售方信息');
          return
        }
        if (res.body.invoiceMerchant == 1) {
          let params = {
            openid: res.body.openid,
            appsecret: res.body.appSecret,
          }
          this.$store.dispatch('invoice/GetToken', params)
        }
        _this.$router.push({ name: 'Invoice-Form' })
        _this.$store.dispatch('invoice/SetInvoiceInfo', res.body)
      })
        .catch(err => {
          alert(err)
          _this.$notify({
            type: 'danger',
            message: err
          })
        })
    },
    handleRefresh () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  color: #444444;
  padding-top: 10vh;
  &__title {
    font-size: 22px;
    line-height: 48px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    letter-spacing: 1.75px;
  }
  &__remark {
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  &__tips {
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  &__countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
    text-align: center;
  }
  &__orderInfo {
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  .bottom {
    margin: 20px auto 20px;
  }

  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
}
</style>
